import middlewares from '@/middlewares/http-common';
import { handlePost } from './common';

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

class VideoService {
  getManifestUrlByName(name) {
    if (isIOS()) {
      return `${middlewares.httpEndpoint}file-transfer/video-dash/${name}/master.m3u8`;
    }
    return `${middlewares.httpEndpoint}file-transfer/video-dash/${name}/manifest.mpd`;
  }

  getTokenizedManifestUrlByName(name, token) {
    if (isIOS()) {
      return `${middlewares.httpEndpoint}${token}/file-transfer/video-dash/${name}/master.m3u8`;
    }
    return `${middlewares.httpEndpoint}${token}/file-transfer/video-dash/${name}/manifest.mpd`;
  }

  async getGalleryVideosInfo(numOfItems, listOfNames) {
    return await handlePost('/file-transfer/videos', {
      numOfItems,
      listOfNames,
    });
  }
}

export default new VideoService();
